import {
  allowNumbersTextOnly,
  allowNumbersOnly,
  hasFullWidthCharacters,
  toASCII,
} from '../helpers'

$(document).ready(() => {
  document.addEventListener(
    'invalid',
    (e) => {
      $(e.target).addClass('invalid')
      if ($('.invalid').length) {
        $('html, body').animate(
          { scrollTop: $($('.invalid')[0]).offset().top - 120 },
          0,
          'swing'
        )
      }
    },
    true
  )

  $('#create_customer').each(function () {
    $(this)
      .find(':input')
      .on('change keydown', (e) => {
        $(e.currentTarget).removeClass('invalid')
      })
  })

  $('#register-post-code')
    .on('keypress paste', (event) => {
      return allowNumbersOnly(event)
    })
    .on('change', (event) => {
      event.target.value = toASCII(event.target.value)
    })
    .on('keydown', (event) => {
      event.target.setCustomValidity('')
      $(event.target).removeClass('invalid')
    })

  $('#register-phone')
    .on('keypress paste', (event) => {
      return allowNumbersOnly(event)
    })
    .on('change', (event) => {
      event.target.value = toASCII(event.target.value)
    })
    .on('keydown', (event) => {
      event.target.setCustomValidity('')
      $(event.target).removeClass('invalid')
    })

  $('#register-last-name')
    .on('keypress paste', (event) => {
      return allowNumbersTextOnly(event)
    })
    .on('keydown', (event) => {
      event.target.setCustomValidity('')
      $(event.target).removeClass('invalid')
    })

  $('#register-first-name')
    .on('keypress paste', (event) => {
      return allowNumbersTextOnly(event)
    })
    .on('keydown', (event) => {
      event.target.setCustomValidity('')
      $(event.target).removeClass('invalid')
    })

  $('#register-last-name2')
    .on('keypress paste', (event) => {
      return allowNumbersTextOnly(event)
    })
    .on('keydown', (event) => {
      event.target.setCustomValidity('')
      $(event.target).removeClass('invalid')
    })

  $('#register-first-name2')
    .on('keypress paste', (event) => {
      return allowNumbersTextOnly(event)
    })
    .on('keydown', (event) => {
      event.target.setCustomValidity('')
      $(event.target).removeClass('invalid')
    })

  $('#register-city')
    .on('keypress paste', (event) => {
      return allowNumbersTextOnly(event)
    })
    .on('keydown', (event) => {
      event.target.setCustomValidity('')
      $(event.target).removeClass('invalid')
    })

  $('#register-adress').on('keydown paste', (event) => {
    event.target.setCustomValidity('')
    $(event.target).removeClass('invalid')
  })

  // Address 1 allows hyphens as well
  $('#register-adress').on('keypress paste', (event) => {
    return allowNumbersTextOnly(event)
  })

  $('#register-number')
    .on('keypress paste', (event) => {
      return allowNumbersTextOnly(event)
    })
    .on('change', (event) => {
      event.target.value = toASCII(event.target.value)
    })
    .on('keydown', (event) => {
      event.target.setCustomValidity('')
      $(event.target).removeClass('invalid')
    })

  $('#register-email').on('change', (event) => {
    $('.form-register .form__head .errors').remove()
    event.target.value = toASCII(event.target.value)
    if (hasFullWidthCharacters(event.target.value)) {
      alert('メールアドレスは半角で入力して下さい')
    } else if (event.target.value.indexOf('@') == -1) {
      alert('メールアドレスを正しく入力してください')
    }
  })
})
